import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const Check = forwardRef<Ref, IconPropsType>(({ color = "currentColor", size, ...rest }, ref) => {
  return (
    <svg
      width={size ?? 16}
      height={size ?? 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346627 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9976 5.87901 15.1539 3.84559 13.6542 2.34582C12.1544 0.84606 10.121 0.00242648 8 0ZM12.1656 6.09062L7.2156 11.0406C7.14134 11.1149 7.05316 11.1739 6.95611 11.2141C6.85906 11.2543 6.75503 11.275 6.64998 11.275C6.54493 11.275 6.4409 11.2543 6.34385 11.2141C6.2468 11.1739 6.15862 11.1149 6.08435 11.0406L3.8344 8.79062C3.68595 8.64029 3.60299 8.43733 3.60365 8.22606C3.60431 8.01478 3.68853 7.81235 3.83793 7.66295C3.98732 7.51355 4.18975 7.42932 4.40103 7.42865C4.61231 7.42798 4.81527 7.51092 4.9656 7.65937L6.64998 9.34375L11.0344 4.95937C11.1847 4.81092 11.3877 4.72798 11.599 4.72865C11.8103 4.72932 12.0127 4.81355 12.1621 4.96295C12.3115 5.11235 12.3957 5.31478 12.3963 5.52606C12.397 5.73733 12.3141 5.94029 12.1656 6.09062Z"
        fill={color}
      />
    </svg>
  );
});
export default Check;
